export const customisedDomains = {
    springworks: 'springrole',
}
